import { apiClient, createApiClient } from "../api/client";

let publicBaseUrl = "http://localhost:8000/api/v1";

export function configurePublicApi(
  baseUrl: string,
  options?: {
    getToken?: () => Promise<string | null>;
    setToken?: (token: string) => Promise<void>;
  },
) {
  publicBaseUrl = baseUrl.replace(/\/+$/, "");
  apiClient.configure({ baseUrl: publicBaseUrl });
  if (options?.getToken || options?.setToken) {
    apiClient.setTokenHandlers({ getToken: options.getToken, setToken: options.setToken });
  }
}

export function getPublicBaseUrl() {
  return publicBaseUrl;
}

export async function publicFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const method = init?.method ?? "GET";
  const headers = init?.headers as Record<string, string> | undefined;
  const body = init?.body as BodyInit | null | undefined;
  return apiClient.request<T>(path, {
    auth: "public",
    method,
    headers,
    body: body as string | null,
    signal: init?.signal ?? undefined,
  });
}

export async function ensureAnonymousSession(): Promise<void> {
  await apiClient.request<void>("/auth/session", { auth: "public", method: "POST" });
}

export { createApiClient };
